<!-- eslint-disable max-len -->
<template>
  <div id="form-page-detail">
    <div
      :class="{ 'form-page-detail--header-long' : !is_sidebar_minimized }"
      class="form-page-detail--header">
      <b-row>
        <b-col md="8">
          <div class="name-data--header">{{ form_data.name }}</div>
          <div class="id-data--header">{{ form_data.id }}</div>
        </b-col>
        <b-col md="4">
          <i
            id="configPopover"
            class="fa fa-ellipsis-v fa-lg cursor-pointer pull-right m__l--10 m__t--10"/>
        </b-col>
      </b-row>
      <b-row
        id="form-header-tab"
        class="form-page-detail--header_tab">
        <b-col
          v-for="tab in tabs"
          :key="tab.id"
          :class="{'studio-page-tab-active' : tabSelected === tab.id}"
          class="studio-page-tab"
          @click="selectTab(tab.id)"
        >
          <h4>{{ tab.label }}</h4>
          <div
            v-if="tabSelected === tab.id"
            class="underline-data"/>
        </b-col>
      </b-row>
    </div>

    <div class="form-page-detail--body">
      <j-form-general
        v-if="tabSelected === 'general'"
        ref="generalRef"
        :switcher="switcher"
      />
      <j-form-column v-if="tabSelected === 'column'"/>
      <j-form-data v-if="tabSelected === 'data'"/>
      <j-form-workflow
        v-if="tabSelected === 'workflow'"
        ref="workflowRef"/>
      <j-form-trigger v-if="tabSelected === 'trigger'"/>
      <j-form-exp-manager v-if="tabSelected === 'exp_manager'"/>
      <j-form-activity-log v-if="tabSelected === 'log'" />
    </div>

    <b-popover
      v-click-outside="closePopover"
      ref="configPopoverRef"
      :show.sync="configPopoverShow"
      target="configPopover"
      placement="leftbottom">
      <div
        class="add-automation"
        @click="openCodeForm">View Code</div>
      <div
        v-show="showBtnDeleteTable"
        class="add-automation"
        @click="deleteFormData">Delete Table</div>
      <div
        v-show="showBtnTruncateTable"
        class="add-automation"
        @click="truncateFormData">Truncate Data</div>
      <div v-show="showBtnArchivePurgingData">
        <div
          class="add-automation"
          @click="openArchivePurgingModal('archive')">Archive Data</div>
        <div
          class="add-automation"
          @click="openArchivePurgingModal('purging')">Purging Data</div>
      </div>
    </b-popover>

    <b-modal
      ref="appCodeFormDataModal"
      class="mod-form modal-code-form-data"
      centered>
      <div class="label-create-form-data">VIEW CODE</div>
      <span
        class="btn-delete"
        @click="copyCode">
        <i class="fa fa-files-o font-weight-bold cursor-pointer"/> Copy
      </span><br>
      <j-monaco-editor
        v-if="showCodeEditor"
        ref="scriptEditor"
        :value="jsonData"
        language="json"
        class="m__t--10"
      />
      <br>
      <b-row>
        <b-col md="6">
          <div style="opacity: 0;">
            <textarea
              id="view-code"
              :value="viewCode"/>
          </div>
        </b-col>
        <b-col md="6">
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeCodeForm">
              Close
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <modal-archive-purging-data
      :mode="selectedMode"
      @close="toggleArchivePurgingModal(true)" />
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-console */
import jFormGeneral from '@/views/data-manager/jFormGeneral';
import jFormColumn from '@/views/data-manager/jFormColumn';
import jFormData from '@/views/data-manager/jFormData';
import jFormWorkflow from '@/views/data-manager/jFormWorkflow';
import jFormTrigger from '@/views/data-manager/jFormTrigger';
import jFormExpManager from '@/views/data-manager/jFormExpManager';
import jFormActivityLog from '@/views/data-manager/jFormActivityLog';
import ModalArchivePurgingData from '@/views/data-manager/popup/ModalArchivePurgingData';
import { mapState, mapActions, mapMutations } from 'vuex';
import jwtDecode from 'jwt-decode';
import ClickOutside from 'vue-click-outside';
import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';
import jMixArchivePurging from '@/mixins/form-data/jMixArchivePurging';

export default {
  components: {
    jFormGeneral,
    jFormColumn,
    jFormData,
    jFormWorkflow,
    jFormTrigger,
    jFormExpManager,
    jMonacoEditor,
    jFormActivityLog,
    ModalArchivePurgingData,
  },
  directives: {
    ClickOutside,
  },
  mixins: [jMixArchivePurging],
  props: {
    formName: {
      type: String,
      default: '',
    },
    formId: {
      type: String,
      default: '',
    },
    switcher: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      jsonData: '',
      viewCode: '',
      darkMode: false,
      configPopoverShow: false,
      tabSelected: 'general',
      tabs: [
        { id: 'general', label: 'GENERAL' },
        { id: 'column', label: 'COLUMN' },
        { id: 'data', label: 'DATA' },
        { id: 'workflow', label: 'WORKFLOW' },
        { id: 'trigger', label: 'TRIGGER' },
        { id: 'exp_manager', label: 'EXPERIENCE MANAGER' },
        { id: 'log', label: 'ACTIVITY LOG' },
      ],
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      showCodeEditor: false,
    };
  },
  computed: {
    ...mapState('jStoreFormUi', ['changes_value_view']),
    ...mapState('jStoreForm', ['form_data', 'privilege_by_me', 'archive_id', 'purging_data']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),

    isAdmin() {
      const role = localStorage.getItem('userRole');
      return Number(role) === 1;
    },

    showBtnDeleteTable() {
      return this.isAdmin || (this.privilege_by_me.includes('delete_table') && !this.privilege_by_me.includes('view_only'));
    },

    showBtnTruncateTable() {
      return this.isAdmin || (this.privilege_by_me.includes('truncate') && !this.privilege_by_me.includes('view_only'));
    },

    showBtnUpdateTable() {
      return this.isAdmin || (this.privilege_by_me.includes('alter_table') && !this.privilege_by_me.includes('view_only'));
    },

    showBtnArchivePurgingData() {
      return (this.isAdmin || (this.privilege_by_me.includes('moderator') && !this.privilege_by_me.includes('view_only'))) && Number(process.env.RLS_ARCHIVE_PURGE) === 1;
    },
  },
  watch: {
    archive_id(val) {
      if (val) this.selectTab('log');
    },

    purging_data(val) {
      if (val) this.selectTab('log');
    },
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading']),
    ...mapActions('jStoreForm', ['deleteForm', 'findFormData', 'truncateForm', 'deleteTable']),
    ...mapMutations('jStoreFormUi', ['setChangesValueView']),

    openCodeForm() {
      this.configPopoverShow = false;
      const reqData = {
        form_data_id: this.formId,
      };
      this.findFormData(reqData).then((param) => {
        const code = param.data;
        delete code.id;
        delete code.created_by;
        delete code.updated_by;
        delete code.created_at;
        delete code.updated_at;
        delete code.company_id;
        this.jsonData = JSON.stringify(code, null, 4);
        this.viewCode = JSON.stringify(code, null, 4);
        this.$refs.appCodeFormDataModal.show();
        setTimeout(() => { this.showCodeEditor = true; }, 500);
      });
    },

    copyCode() {
      const codeToCopy = document.querySelector('#view-code');
      codeToCopy.setAttribute('type', 'text');
      codeToCopy.select();

      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        // eslint-disable-next-line
        alert('Code was copied ' + msg);
      } catch (err) {
        // eslint-disable-next-line
        alert('Oops, unable to copy');
      }

      /* unselect the range */
      window.getSelection().removeAllRanges();
    },

    closeCodeForm() {
      this.jsonData = '';
      this.showCodeEditor = false;
      this.$refs.appCodeFormDataModal.hide();
    },

    selectTab(data) {
      if (this.changes_value_view) {
        const text = 'Are you sure want to move without save your changes ?';
        this.$swal({
          title: 'Warning',
          text,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          confirmButtonColor: '#D2232A',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then(async (result) => {
          if (result.value) {
            this.tabSelected = data;
            this.setChangesValueView(false);
          }
        });
      } else {
        this.tabSelected = data;
      }
    },

    deleteFormData() {
      this.configPopoverShow = false;
      if (this.form_data.type !== 'thirdparty') {
        this.$swal({
          title: 'Delete Table',
          text: 'Are you sure want to delete this table?',
          showCancelButton: true,
          confirmButtonText: 'Delete',
        }).then((result) => {
          if (result.value) {
            // const param = { id: this.formId };
            // const session = this.session;
            // this.deleteForm({ param, session }).then((res) => {
            //   if (res.error) {
            //     console.log(res);
            //     this.toggleProblem(res.message);
            //   }
            // });

            const param = {
              id: this.formId,
              tablegroup_id: this.$route.params.id,
            };
            this.deleteTable(param).then((res) => {
              if (res.error) {
                this.toggleProblem(res.message);
              } else if (!res.error && res.error_session) {
                this.toggleInfo(res.message);
              }
            });
          }
        });
      } else {
        this.toggleProblem('Can’t delete table type thirdparty');
      }
    },

    truncateFormData() {
      this.configPopoverShow = false;
      if (this.form_data.type !== 'thirdparty') {
        this.$swal({
          title: 'Truncate Table',
          text: 'Are you sure want to truncate this data?',
          showCancelButton: true,
          confirmButtonText: 'Truncate',
        }).then((result) => {
          if (result.value) {
            const param = {
              tablegroup_id: this.$route.params.id,
              form_data_id: this.formId,
            };
            const paramGroup = {
              tablegroup_id: this.$route.params.id,
            };
            const session = this.session;
            this.truncateForm({ param, session, paramGroup }).then((res) => {
              if (res.error) {
                this.toggleProblem(res.message);
              } else if (!res.error && res.error_session) {
                this.toggleInfo(res.message);
              }
            });
          }
        });
      } else {
        this.toggleProblem('Can’t truncate data from table type thirdparty');
      }
    },

    submitData() {
      this.$refs[`${this.tabSelected}Ref`].submitForm();
    },

    closePopover() {
      this.configPopoverShow = false;
    },
  },
};
</script>

<style lang="scss">
  #form-page-detail {
    // height: 100%;
    .form-page-detail--header-long {
      width: calc(100% - 375px) !important;
    }

    .form-page-detail--header {
      // background-color: #ffffff;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      padding: 21px 15px 1px 15px;
      height: 127px;
      color: #525252;
      position: fixed;
      width: calc(100% - 565px);
      z-index: 10;
      background-color: #ffffff;
      border-bottom: 1px solid #f2f2f2;
    }
    .form-page-detail--header_tab {
      text-align: center;
      margin-top: 28px;
    }
    .form-page-detail--body {
      // height: 83%;
      padding: 130px 5px 15px 0px !important;
    }
    .name-data--header {
      color: #525252;
      font-family: 'Poppins-Medium';
      font-size: 18px;
    }
    .id-data--header {
      color: #525252;
      font-family: 'Poppins-Regular';
      font-size: 12px;
    }
  }

  .btn-view-code {
    float: right;
    width: 100px;
    height: 24px;
    padding: 5px;
    margin-right: 5px;
    border-radius: 4px;
    background-color: #f2f2f2;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4a4a4a;
    cursor: pointer;
  }

  .btn-delete {
    float: right;
    width: 72px;
    height: 24px;
    padding: 5px;
    border-radius: 4px;
    background-color: #f2f2f2;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4a4a4a;
    cursor: pointer;
  }

  #form-header-tab {
    .col {
      flex-grow: 0;
    }
  }

  .btn-blue-form-data {
    background-color: #E3F1FE !important;
    color: #1A85E4 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/data-manager/jFormPageDetail.vue